"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNearestActiveWeekDayFromArray = void 0;
var getNearestActiveWeekDayFromArray = function (activeDaysPerWeek) {
    var currentDayOfWeek = new Date().getDay();
    var nearestDayOfWeek;
    nearestDayOfWeek = activeDaysPerWeek.find(function (day) { return day === currentDayOfWeek; });
    if (!nearestDayOfWeek)
        activeDaysPerWeek === null || activeDaysPerWeek === void 0 ? void 0 : activeDaysPerWeek.forEach(function (day) {
            if (day > currentDayOfWeek)
                nearestDayOfWeek = day;
        });
    if (!nearestDayOfWeek)
        nearestDayOfWeek = (activeDaysPerWeek === null || activeDaysPerWeek === void 0 ? void 0 : activeDaysPerWeek[0]) || currentDayOfWeek;
    return nearestDayOfWeek;
};
exports.getNearestActiveWeekDayFromArray = getNearestActiveWeekDayFromArray;
